export default __webpack_public_path__ + "static/media/mariog13.282a3a67.jpg";